import { Device } from "common/device";
import { Button } from "components/common/button/Button";
import { CheckBox } from "components/common/checkBox/CheckBox";
import { TermCheckBox } from "components/common/termCheckBox/TermCheckBox";
import { useAtom } from "jotai";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { stepAtom } from "store/signUpStore";

export const SignUpStep1 = () => {
    const {t} = useTranslation();
    const [step, setStep] = useAtom(stepAtom);

    const [term1Checked, setTerm1Checked] = useState(false);
    const [term2Checked, setTerm2Checked] = useState(false);
    const [term3Checked, setTerm3Checked] = useState(false);

    return (
        <div className="sign-up-info" style={{display: step === 1 ? "block" : "none"}}>
            <span className="title">{t("signUp.needAuthTitle")}</span>
            <span className="info">{t("signUp.needAuthInfo")}</span>

            <span className="info" style={{marginTop: "50px"}}>{t("signUp.needAuthInfo2")}</span>

            <div style={{display: "flex", flexDirection: "column", marginTop: "50px"}}>
                <CheckBox
                    title={t("signUp.term1")} id="over_14"
                    checked={term1Checked}
                    setChecked={setTerm1Checked}
                />
                {/* <CheckBox
                    title={t("signUp.term2")} id="personal_info"
                    checked={term2Checked}
                    setChecked={setTerm2Checked}
                />
                <CheckBox
                    title={t("signUp.term3")} id="personal_info2"
                    checked={term3Checked}
                    setChecked={setTerm3Checked}
                /> */}
                <TermCheckBox
                    title={t("signUp.term2")} id="personal_info"
                    checked={term2Checked}
                    setChecked={setTerm2Checked}
                />
                <TermCheckBox
                    title={t("signUp.term3")} id="personal_info2"
                    checked={term3Checked}
                    setChecked={setTerm3Checked}
                />
            </div>

            <div style={{position: 'fixed', bottom: Device.inset.navigationBarHeight, width: '100%', left: 0, padding: "0 20px 20px"}}>
                <Button
                    text={t("signUp.btnAuth")}
                    onPress={() => {setStep(2)}}
                />
            </div>
        </div>
    )
};